import axiosInstance from "utils/axiosInterceptor";

export function list(data: any) {
  return axiosInstance({
    url: "/agencyType/list?" + data,
    method: "get",
  });
}

export function create(data: any) {
  return axiosInstance({
    url: "/agencyType/create",
    method: "post",
    data: data,
  });
}

export function updateById(data: any) {
  return axiosInstance({
    url: "/agencyType/updateById/" + data.id,
    method: "put",
    data: data,
  });
}

export function getById(id: string) {
  return axiosInstance({
    url: "/agencyType/getById/" + id,
    method: "get",
  });
}

export function deleteById(id: string) {
  return axiosInstance({
    url: "/agencyType/deleteById/" + id,
    method: "delete",
  });
}

export const apiMethod = { list, create, updateById, getById, deleteById };
